import type { Project } from './projects.d';

export const projects: Project[] = [
  {
    title: 'RAG Chatbot',
    description:
      'A high-performance RAG chatbot built with LangGraph, Groq, and Pinecone. Features an intelligent router that proactively switches between document retrieval and Tavily web search, providing comprehensive answers via a modern Streamlit interface. Includes execution tracing and is Docker-ready for easy deployment.',
    tags: ['Ai', 'Llm', 'Rag', 'Agentic Workflow'],
    technologies: ['Python', 'LangGraph', 'Pinecone', 'Groq', 'Streamlit', 'Docker'],
    github: 'https://github.com/aminul01-g/groq-langgraph-rag',
    slug: 'groq-langgraph-rag',
    thumbnail: '\ud83e\udd16',
    demoUrl: 'https://github.com/aminul01-g/groq-langgraph-rag',
    featured: true,
    date: '2025-12-25',
    role: 'AI Engineer',
    videoUrl: 'https://drive.google.com/file/d/1fQf4VwsC1ImUJouLbATtax5mKs9WIzl1/view?usp=sharing',
    caseStudy: {
      problem: 'Enterprise users struggle to find specific information within large internal document repositories, and traditional keyword search often fails to capture semantic meaning or context.',
      solution: 'Architected a RAG pipeline using LangGraph for orchestration and Pinecone for vector storage. Implemented a hybrid search router that dynamically delegates between document retrieval and Tavily web search based on query complexity.',
      impact: 'Reduced information retrieval time by 60% and improved answer accuracy by 40% compared to keyword-based baseline. The system now supports multi-turn conversations with context spread across different domains.',
    },
  },
  {
    title: 'Krishi Bondhu',
    description:
      'KrishiBondhu \u2013 AI-Powered Farmer Assistant built during BUBT Tech Fusion Fest 2025 Hackathon, organized by BASIS Student Forum BUBT. Complete project source code included.',
    tags: ['Web App', 'Agriculture', 'React', 'Ai'],
    technologies: ['React', 'Node.js', 'Express', 'TailwindCSS', 'MongoDB', 'Framer Motion'],
    github: 'https://github.com/aminul01-g/krishi-bondhu',
    slug: 'krishi-bondhu',
    thumbnail: '\ud83c\udf3e',
    demoUrl: 'https://krishi-bondhu-rwjp.vercel.app',
    featured: true,
    date: '2025-11-17',
    role: 'Full Stack Developer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    caseStudy: {
      problem: 'Farmers lack access to real-time, localized agricultural advice, leading to suboptimal crop yield and poor disease management in crops.',
      solution: 'Developed an AI-powered farmer assistant web app integrating LLMs for contextual advice, disease detection models, and a responsive React frontend.',
      impact: 'Won recognition at BUBT Tech Fusion Fest 2025. Empowered early testers with instant actionable farming advice and high-accuracy disease diagnostics from crop images.',
    },
  },
  {
    title: 'University Management System',
    description:
      'This is a group project  for Advance programming (CSE341) course on University Management System (UMS) \u2014 a console-based Java application that efficiently manages students, teachers, and courses.',
    tags: ['Software Engineering', 'Java', 'Sql'],
    technologies: ['Java', 'Swing', 'MySQL', 'JDBC'],
    github: 'https://github.com/aminul01-g/University-Management-System',
    slug: 'university-management-system',
    thumbnail: '\ud83c\udf93',
    demoUrl: 'https://github.com/aminul01-g/University-Management-System',
    featured: true,
    date: '2025-11-08',
    role: 'Backend Developer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    caseStudy: {
      problem: 'Manual university administration processes were time-consuming and prone to errors, making it difficult to track students, courses, and grades efficiently.',
      solution: 'Built a robust console-based Java application with a structured MySQL database using JDBC, supporting CRUD operations for students, teachers, and courses.',
      impact: 'Streamlined university record management, eliminating data duplication and reducing query times by over 80%. Achieved a perfect score in the Advanced Programming course.',
    },
  },
  {
    title: 'Multi-Tool Medical AI',
    description:
      'A multi-tool AI agent built with LangChain and OpenAI that answers data-specific queries from medical datasets (Heart Disease, Cancer, Diabetes) and retrieves general medical knowledge via web search.',
    tags: ['Ai', 'Agents', 'Langchain'],
    technologies: ['Python', 'LangChain', 'OpenAI', 'Pandas'],
    github: 'https://github.com/aminul01-g/multi-tool-medical-ai',
    slug: 'multi-tool-medical-ai',
    thumbnail: '\ud83e\ude7a',
    demoUrl: 'https://github.com/aminul01-g/multi-tool-medical-ai',
    featured: false,
    date: '2025-09-21',
    role: 'AI Engineer',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
  },
  {
    title: 'Stress Level Detection',
    description:
      'The Stress Level Detection System is a machine learning-powered web application that helps users monitor and analyze their stress levels.',
    tags: ['Ml', 'Healthcare', 'Analytics'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/Stress-Level-Detection-System',
    slug: 'stress-level-detection-system',
    thumbnail: '\ud83e\uddd8',
    demoUrl: 'https://github.com/aminul01-g/Stress-Level-Detection-System',
    featured: false,
    date: '2025-09-10',
    role: 'Data Scientist',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4',
  },
  {
    title: 'LinkedIn Post Generator',
    description:
      'simple, easy-to-understand AI-powered LinkedIn post generator that helps create professional posts from your ideas',
    tags: ['Ai', 'Nlp', 'Genai'],
    technologies: ['Python'],
    github: 'https://github.com/aminul01-g/LinkedinPostGenerator',
    slug: 'linkedinpostgenerator',
    thumbnail: '\u270d\ufe0f',
    demoUrl: 'https://github.com/aminul01-g/LinkedinPostGenerator',
    featured: false,
    date: '2025-09-09',
    role: 'Developer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4',
  },
  {
    title: 'QA Transformers Finetune',
    description:
      'Fine-tuning a pre-trained BERT model on the SQuAD v1.1 dataset for Question Answering tasks using Hugging Face Transformers. Includes dataset preprocessing, model training, evaluation, and testing on custom questions.',
    tags: ['Nlp', 'Transformers', 'Qa'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/qa-transformers-finetune',
    slug: 'qa-transformers-finetune',
    thumbnail: '\ud83d\udd27',
    demoUrl: 'https://github.com/aminul01-g/qa-transformers-finetune',
    featured: false,
    date: '2025-09-01',
    role: 'ML Engineer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4',
  },
  {
    title: 'IMDB Sentiment Analysis',
    description:
      'NLP, Sentiment-Analysis, IMDB, Machine-Learning, Deep-Learning, BERT, Word2Vec, TF-IDF, Python',
    tags: ['Nlp', 'Sentiment', 'Deep Learning'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/IMDB-Sentiment-Analysis',
    slug: 'imdb-sentiment-analysis',
    thumbnail: '\ud83c\udfac',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/IMDB-Sentiment-Analysis',
    featured: false,
    date: '2025-08-27',
    role: 'ML Engineer',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  },
  {
    title: 'Next Word Prediction',
    description:
      'Implements a word-level LSTM model in PyTorch for next word prediction using NLP techniques. Includes data preprocessing, custom dataset creation, model training, and inference on real-world text.',
    tags: ['Nlp', 'Lstm', 'Prediction'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/Next_Word_Prediction-LSTM',
    slug: 'next_word_prediction-lstm',
    thumbnail: '\ud83d\udcdd',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/Next_Word_Prediction-LSTM',
    featured: false,
    date: '2025-08-08',
    role: 'ML Engineer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
  },
  {
    title: 'People Flow Tracker',
    description:
      'An AI-powered people flow tracking system using YOLOv8 and ByteTrack to count entries/exits and visualize motion intensity via real-time heatmaps. Includes full Python/Colab pipeline, annotated video output, and final heatmap generation for video surveillance and smart analytics applications.',
    tags: ['Computer Vision', 'Yolo', 'Tracking'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/people-flow-tracker-yolov8',
    slug: 'people-flow-tracker-yolov8',
    thumbnail: '\ud83d\udc65',
    demoUrl: 'https://github.com/aminul01-g/people-flow-tracker-yolov8',
    featured: false,
    date: '2025-08-05',
    role: 'CV Engineer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
  },
  {
    title: 'QA Prediction RNN',
    description:
      'This project implements a simple Recurrent Neural Network (RNN) based question answering model using PyTorch. The model is trained on a small dataset of unique question-answer pairs to demonstrate the basic principles of building a sequence-to-sequence model for this task.',
    tags: ['Nlp', 'Rnn', 'Qa'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/Question_Answer_prediction-RNN',
    slug: 'question_answer_prediction-rnn',
    thumbnail: '\u2753',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/Question_Answer_prediction-RNN',
    featured: false,
    date: '2025-08-03',
    role: 'ML Engineer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4',
  },
  {
    title: 'Fashion Mnist Nn Vs Cnn',
    description:
      'A comparative study of Neural Networks and Convolutional Neural Networks on the Fashion MNIST dataset using PyTorch.',
    tags: ['Jupyter Notebook'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/fashion-mnist-nn-vs-cnn',
    slug: 'fashion-mnist-nn-vs-cnn',
    thumbnail: '\ud83d\udcbb',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/fashion-mnist-nn-vs-cnn',
    featured: false,
    date: '2025-07-26',
    role: 'Developer',
  },
  {
    title: 'Digit Classifier',
    description:
      'This repository contains code for classifying with high accuracy  handwritten digits from the MNIST dataset using a simple feedforward neural network implemented in PyTorch.',
    tags: ['Computer Vision', 'Classification', 'Neural Networks'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/Digit_Classification-acc-98.43',
    slug: 'digit_classification-acc-98.43',
    thumbnail: '\ud83d\udd22',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/Digit_Classification-acc-98.43',
    featured: false,
    date: '2025-07-17',
    role: 'ML Engineer',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4',
  },
  {
    title: 'Clothing Classifier',
    description:
      'A deep learning model (ANN) trained on the Fashion MNIST dataset using PyTorch. This project demonstrates how to train, save, and deploy a neural network to classify clothing items like shirts, sneakers, trousers, and more.',
    tags: ['Computer Vision', 'Fashion', 'Cnn'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/clothing-classifier',
    slug: 'clothing-classifier',
    thumbnail: '\ud83d\udc55',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/07_DeepLearning/clothing-classifier',
    featured: false,
    date: '2025-07-17',
    role: 'ML Engineer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  },
  {
    title: 'Clustering Iris Dataset',
    description:
      "Unsupervised Clustering on Iris Dataset using K-Means, Hierarchical, and DBSCAN with EDA & Evaluation This project applies three unsupervised clustering algorithms to the Iris dataset and visualizes the results using PCA, dendrograms, and DBSCAN's density estimation. Evaluation includes confusion matrix and Adjusted Rand Index.",
    tags: ['Jupyter Notebook'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Clustering_Iris_Dataset',
    slug: 'clustering_iris_dataset',
    thumbnail: '\ud83d\udcbb',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Clustering_Iris_Dataset',
    featured: false,
    date: '2025-07-14',
    role: 'Developer',
  },
  {
    title: 'Personality Detection',
    description:
      'I built a predictive model to classify people as Extroverts or Introverts based on behavioral features like energy level, emotional stability, and openness.  \ud83d\udcda Used a psychological dataset and trained models like Logistic Regression, Decision Tree, and Naive Bayes.',
    tags: ['Ml', 'Nlp', 'Classification'],
    technologies: ['Jupyter Notebook'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Personality_Detection-Extrovert_vs_Introvert',
    slug: 'personality_detection-extrovert_vs_introvert',
    thumbnail: '\ud83c\udfad',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Personality_Detection-Extrovert_vs_Introvert',
    featured: false,
    date: '2025-07-10',
    role: 'ML Researcher',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4',
  },
  {
    title: 'Diabetes Detection AI',
    description:
      'This project uses machine learning algorithms to predict whether a person is diabetic based on medical diagnostic measurements. It is built using Python and trained on the Pima Indians Diabetes Dataset from the UCI Machine Learning Repository.',
    tags: ['Healthcare', 'Ml', 'Python'],
    technologies: ['Python', 'scikit-learn', 'Flask', 'Docker'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Diabetes-Detection-System',
    slug: 'diabetes-detection-system',
    thumbnail: '\ud83c\udfe5',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Diabetes-Detection-System',
    featured: false,
    date: '2025-07-05',
    role: 'ML Engineer',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4',
  },
  {
    title: 'AI Study Assistant API',
    description:
      'A desktop AI Study Assistant built with Python/Tkinter and powered by Google Gemini to help students manage tasks, track study time, and generate quizzes.',
    tags: ['Ai', 'Education', 'Api'],
    technologies: ['Python'],
    github: 'https://github.com/aminul01-g/ai_study_assistent_with-API-',
    slug: 'ai_study_assistent_with-api-',
    thumbnail: '\ud83d\udcd6',
    demoUrl: 'https://github.com/aminul01-g/ai_study_assistent_with-API-',
    featured: false,
    date: '2025-06-14',
    role: 'Full Stack Developer',
    videoUrl: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4',
  },
  {
    title: 'Ames Housing Prediction',
    description:
      'This project demonstrates a full machine learning pipeline for predicting house prices using a simulated version of the Ames Housing dataset.',
    tags: ['Data Science', 'Regression', 'Python'],
    technologies: ['Python', 'pandas', 'numpy', 'scikit-learn', 'Matplotlib'],
    github: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Predictive-Modeling-of-Ames-Housing-Data',
    slug: 'predictive-modeling-of-ames-housing-data',
    thumbnail: '\ud83c\udfe0',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub/tree/main/06_MachineLearning/Predictive-Modeling-of-Ames-Housing-Data',
    featured: false,
    date: '2025-06-14',
    role: 'Data Scientist',
    videoUrl:
      'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4',
  },
  {
    title: 'Cpp',
    description:
      'A comprehensive collection of my personal C++ and C code. This repository serves as a practical guide and learning resource, covering everything from fundamental algorithms and data structures to advanced programming patterns and competitive problem-solving.',
    tags: ['C++'],
    technologies: ['C++'],
    github: 'https://github.com/aminul01-g/CPP',
    slug: 'cpp',
    thumbnail: '\ud83d\udcbb',
    demoUrl: 'https://github.com/aminul01-g/CPP',
    featured: false,
    date: '2025-05-17',
    role: 'Developer',
  },
  {
    title: 'My Learning Hub',
    description:
      '\ud83d\udcd8 A curated collection of notes, code, and resources documenting my AI/ML learning journey \u2014 covering Python, data science, machine learning, deep learning, gen-ai, agentic-ai, deployment, and beyond.',
    tags: ['Python'],
    technologies: ['Python'],
    github: 'https://github.com/aminul01-g/my-learning-hub',
    slug: 'my-learning-hub',
    thumbnail: '\ud83d\udcbb',
    demoUrl: 'https://github.com/aminul01-g/my-learning-hub',
    featured: false,
    date: '2025-05-15',
    role: 'Developer',
  },
];
